export default {
  notification: {
    canceled: 'The checkout as been canceled',
    success: 'Subscription proceeded',
  },
  tooltip: 'subscription required',
  subscribed: {
    summary: {
      title: 'Subscription Summary',
      plan: 'Plan',
      frequency: 'Billing period',
      subscribed_at: 'Creation date',
      price: 'Price',
    },
    portal: {
      title: 'Manage my Subscription',
      description:
        'Open the Stripe portal to manage all your subscription information like:\n' +
        'manage your payment method, billing information or download invoices.',
      button: 'Open Portal',
      section: {
        plan: {
          title: 'Change Plan',
          description: 'Update your subscription to a plan that feet your needs.\nYou can change plan at any time',
          button: 'Update plan',
        },
        payment: {
          title: 'Payment Method',
          description: 'Change the card used for direct debit, or use another payment method.',
          button: 'Change payment method',
        },
        info: {
          title: 'Billing Information',
          description: 'Change your name, email or mailing address associated with billing.',
          button: 'Update information',
        },
        invoice: {
          title: 'Invoice History',
          description: 'Find the status and history of previous invoices, or download receipts and invoices.',
          button: 'Accessing Invoices',
        },
      },
    },
  },
  unsubscribed: {
    portal: {
      title: 'We have a plan for everyone',
      button: 'Choose this plan',
      current: 'Current plan',
    },
  },
  join: {
    title: 'Join a group',
    separator: 'or start an standalone subscription',
    button: 'join the group',
    helper: {
      singleOrganization_one: 'Join the group currently composed of the spot:',
      singleOrganization_other: 'Join the group currently composed of the spots:',
      multipleOrganization: 'Join on of the following groups:',
    },
    tooltip: {
      join: 'join',
      quota: 'number of spot quota is reached',
    },
  },
  price: '{{count, currency(currency: EUR)}}',
  frequency: {
    per: {
      monthly: '/month',
      yearly: '/year',
    },
    name: {
      monthly: 'Monthly',
      yearly: 'Yearly',
    },
  },
  plans: {
    none: 'Free Trial',
    small: 'Plan 4C',
    medium: 'Plan 6A',
    large: 'Plan 7B',
  },
  headings: {
    none: 'for 1 month',
    small: 'to start up',
    medium: 'the most popular',
    large: 'for advanced gym',
  },
  quotaType: {
    route_one: 'multiple routes',
    route_other: '{{count}} routes',
    route_zero: 'unlimited routes',
    membership_one: 'multiple admin / setters',
    membership_other: '{{count}} admin / setters',
    membership_zero: 'unlimited admin / setters',
    comment: 'comments',
    tick: 'tick notebook',
    sector_one: '1 sector',
    sector_other: '{{count}} sectors',
    sector_zero: 'unlimited sectors',
    spot_one: '1 spot',
    spot_other: '{{count}} spots',
    spot_zero: 'unlimited spots',
  },
  featureType: {
    visit: 'visiteurs illimités',
    stats: 'statistiques',
  },
  stripe: 'For more security, VerticalTopo relies on the Stripe platform to manage your subscription.',
  redirect: {
    no_spot: 'Sorry, no spot found!',
    select: 'Please select the spot you want to manage',
  },
}
